import { gql } from "@apollo/client";
import {useQuery} from '@apollo/client/react';
// Assurez-vous que le chemin d'importation est correct
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

export const GET_ALL_SKILLS = gql`
  query GetAllSkills($skillsRequest: SkillsRequestDto!) {
    skills(skillsRequest: $skillsRequest) {
        skills {
        companyUuid
        escoUri
        labelDe
        labelEn
        labelEs
        labelFr
        labelIt
        labelNl
        skillAssignedUsers {
            email
            firstname
            gender
            language
            lastname
            trigram
            uuid
        }
        skillAssignedUsersCount
        skillType
        uuid
        }
    hasNext
    }
  }
`;
export const useAllSkills = (searchString, sliceNumber=1, sortOrder) => {
    const user = useAppSelector((state) => state.auth.currentUser);

    const { loading, error, data, refetch } = useQuery(GET_ALL_SKILLS, {
        variables: { skillsRequest: { companyUuid: user.company.uuid, searchString, sliceNumber, sortOrder } },
        fetchPolicy: "network-only", // S'assure que les données sont toujours récupérées depuis le serveur
    });

    return { loading, error, data, refetch };
};
